function activateCollectionCarousel(){

    var collectionCarousels = document.querySelectorAll(".collection-carousel-container")
    collectionCarousels.forEach(collectionCarousel => {
        var carouselContainer = collectionCarousel.querySelector(".carousel-container")
        var carousel = collectionCarousel.querySelector(".carousel-slides")
        
        if(!carouselContainer)
            return

        var prevButton = collectionCarousel.querySelector(".prev")
        var nextButton = collectionCarousel.querySelector(".next")
        var carouselSlides = carouselContainer.querySelectorAll(".carousel-slide")
        var slideWidth = carouselSlides[0].offsetWidth
        var totalWidth = carousel.scrollWidth;

        // Event listener for PREV scroll button
        prevButton.addEventListener("click", () => {
            carousel.scrollTo({ left: carousel.scrollLeft - slideWidth, behavior: 'smooth' });
            nextButton.classList.remove("inactive")
        });
        
        // Event listener for NEXT scroll button
        nextButton.addEventListener("click", () => {
            carousel.scrollTo({ left: carousel.scrollLeft + slideWidth, behavior: 'smooth' });
            prevButton.classList.remove("inactive")
        });

        carousel.addEventListener("scrollend", () => {
            const scrollPosition = carousel.scrollLeft;
        
            // Check if at the start
            if (scrollPosition <= 0) {
                // disable prev button
                prevButton.classList.add("inactive")
            }
        
            // Check if at the end
            if (scrollPosition >= totalWidth - carousel.clientWidth) {
                // disable next button
                nextButton.classList.add("inactive")
            }
        });

    });
}

window.addEventListener("load", function() {
    try {
        activateCollectionCarousel();
    } catch (error) {
        console.error("Error in activateCollectionCarousel:", error);
    }
});